import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDomainConfig } from '../config/domainConfig';

const Login = () => {
  const domainConfig = getDomainConfig();
  const [form, setForm] = useState({ email: '', password: '', tenant_code: domainConfig.tenant_code });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const isBranded = !!domainConfig.tenant_code;
  const primary = domainConfig.primary_color || '#1B6B3A';

  useEffect(() => {
    document.title = domainConfig.app_name || 'FibraDesk';
    setTimeout(() => setMounted(true), 80);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(form.email, form.password, form.tenant_code);
      if (res?.user?.role === 'crm_staff') navigate('/crm');
      else if (res?.user?.role === 'lco') navigate('/lco');
      else navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ height:'100vh', display:'flex', fontFamily:"'Segoe UI',-apple-system,sans-serif", overflow:'hidden' }}>
      <style>{`
        @keyframes fadeIn { from{opacity:0;transform:translateX(-20px)} to{opacity:1;transform:translateX(0)} }
        @keyframes fadeInR { from{opacity:0;transform:translateX(20px)} to{opacity:1;transform:translateX(0)} }
        @keyframes pulse { 0%,100%{opacity:.4} 50%{opacity:.8} }
        .finp { width:100%; padding:12px 16px; border:1.5px solid #e8edf2; border-radius:10px; font-size:14px; color:#1a2332; background:#fafbfc; outline:none; box-sizing:border-box; transition:all .2s; font-family:inherit; }
        .finp:focus { border-color:${primary}; background:white; box-shadow:0 0 0 4px ${primary}12; }
        .finp::placeholder { color:#adb5bd; }
        .sbtn { width:100%; padding:13px; background:${primary}; color:white; border:none; border-radius:10px; font-size:14px; font-weight:700; cursor:pointer; transition:all .2s; letter-spacing:0.3px; font-family:inherit; }
        .sbtn:hover:not(:disabled) { filter:brightness(1.08); transform:translateY(-1px); box-shadow:0 6px 20px ${primary}40; }
        .sbtn:active { transform:translateY(0); }
        .sbtn:disabled { opacity:.6; cursor:not-allowed; transform:none; }
        .stat-item:hover { background:rgba(255,255,255,0.15) !important; }
        @media (max-width: 768px) {
          .left-panel { display: none !important; }
          .right-panel { padding: 32px 24px !important; }
          .finp { padding: 14px 16px !important; font-size: 16px !important; }
          .sbtn { padding: 15px !important; font-size: 16px !important; }
        }
      `}</style>

      {/* LEFT PANEL */}
      <div className='left-panel' style={{ width:'52%', background:`#0a1b0f`, display:'flex', flexDirection:'column', position:'relative', overflow:'hidden',
        opacity: mounted ? 1 : 0, transform: mounted ? 'translateX(0)' : 'translateX(-20px)', transition:'opacity .5s ease, transform .5s ease' }}>

        {/* Diagonal accent */}
        <div style={{ position:'absolute', top:0, right:'-60px', width:'120px', height:'100%', background:`${primary}30`, transform:'skewX(-6deg)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', top:0, right:'-20px', width:'40px', height:'100%', background:`${primary}20`, transform:'skewX(-6deg)', pointerEvents:'none' }} />

        {/* Dot pattern */}
        <div style={{ position:'absolute', inset:0, backgroundImage:`radial-gradient(circle, ${primary}25 1px, transparent 1px)`, backgroundSize:'32px 32px', pointerEvents:'none' }} />

        {/* Bottom glow */}
        <div style={{ position:'absolute', bottom:'-100px', left:'-100px', width:'400px', height:'400px', background:`${primary}20`, borderRadius:'50%', filter:'blur(80px)', pointerEvents:'none' }} />

        <div style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'space-between', padding:'20px 36px', position:'relative', zIndex:1 }}>
          <div>
            <img src="/uploads/photos/nexus_dark_v2.png" alt="KV Nexus" style={{ width:'85%', maxWidth:'340px', objectFit:'contain', display:'block' }} />
          </div>
          <div>
            <div style={{ display:'inline-block', background:'rgba(74,222,128,0.15)', border:'1px solid rgba(74,222,128,0.3)', borderRadius:'20px', padding:'3px 12px', fontSize:'11px', color:'#4ade80', fontWeight:'600', marginBottom:'10px', letterSpacing:'0.5px' }}>✦ PDIC SUPPORT PLATFORM</div>
            <h1 style={{ margin:'0 0 8px', fontSize:'20px', fontWeight:'800', color:'white', lineHeight:1.2 }}>Smarter network<br/>support starts here</h1>
            <p style={{ margin:'0 0 14px', fontSize:'12px', color:'rgba(255,255,255,0.5)', lineHeight:1.5 }}>Manage broadband complaints, track network issues, and deliver faster resolutions.</p>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'6px', maxWidth:'340px' }}>
              {[{label:'Sub-distributions',value:'8',icon:'🏢'},{label:'WhatsApp bot',value:'Live',icon:'💬'},{label:'AI diagnostics',value:'Active',icon:'🧠'},{label:'Real-time alerts',value:'On',icon:'🔔'}].map((s,i) => (
                <div key={i} style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'8px', padding:'8px 10px' }}>
                  <div style={{ fontSize:'14px', marginBottom:'2px' }}>{s.icon}</div>
                  <div style={{ fontSize:'12px', fontWeight:'700', color:'white' }}>{s.value}</div>
                  <div style={{ fontSize:'10px', color:'rgba(255,255,255,0.4)' }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
          <p style={{ margin:0, fontSize:'12px', color:'rgba(255,255,255,0.5)' }}>@2026 Pradesika Digital Internet and Communication LTD</p>
        </div>

      </div>
      {/* RIGHT PANEL */}
      <div className='right-panel' style={{ flex:1, background:'white', display:'flex', alignItems:'center', justifyContent:'center', padding:'48px', overflowY:'auto',
        opacity: mounted ? 1 : 0, transform: mounted ? 'translateX(0)' : 'translateX(20px)', transition:'opacity .5s ease .1s, transform .5s ease .1s' }}>
        <div style={{ width:'100%', maxWidth:'380px' }}>
          <div style={{ marginBottom:'24px', textAlign:'center' }}>
            {domainConfig.logo_url && (
              <img src={domainConfig.logo_url} alt={domainConfig.app_name}
                style={{ height:'56px', maxWidth:'180px', objectFit:'contain', display:'block', margin:'0 auto 16px' }} />
            )}
            <h2 style={{ margin:'0 0 4px', fontSize:'22px', fontWeight:'800', color:'#0d1f15', letterSpacing:'-0.3px' }}>Welcome back</h2>
            <p style={{ margin:0, fontSize:'13px', color:'#64748b' }}>Sign in to your account to continue</p>
          </div>

          {error && (
            <div style={{ padding:'13px 16px', background:'#fff5f5', border:'1px solid #fed7d7', borderRadius:'10px', marginBottom:'24px', fontSize:'13px', color:'#c53030', display:'flex', alignItems:'center', gap:'10px' }}>
              <span style={{ flexShrink:0 }}>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {!isBranded && (
              <div style={{ marginBottom:'18px' }}>
                <label style={{ display:'block', fontSize:'12px', fontWeight:'700', color:'#374151', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'0.6px' }}>Tenant Code</label>
                <input className="finp" type="text" placeholder="e.g. PDIC" value={form.tenant_code}
                  onChange={e => setForm({...form, tenant_code: e.target.value.toUpperCase()})} required />
              </div>
            )}

            <div style={{ marginBottom:'18px' }}>
              <label style={{ display:'block', fontSize:'12px', fontWeight:'700', color:'#374151', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'0.6px' }}>Email / LCO Code</label>
              <input className="finp" type="text" placeholder="Email / LCO Code / Phone" value={form.email}
                onChange={e => setForm({...form, email: e.target.value})} required autoFocus={isBranded} />
            </div>

            <div style={{ marginBottom:'28px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'7px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#374151', textTransform:'uppercase', letterSpacing:'0.6px' }}>Password</label>
              </div>
              <div style={{ position:'relative' }}>
                <input className="finp" type={showPassword ? 'text' : 'password'} placeholder="Enter your password" value={form.password}
                  onChange={e => setForm({...form, password: e.target.value})} required style={{ paddingRight:'48px' }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  style={{ position:'absolute', right:'14px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', fontSize:'16px', color:'#94a3b8', padding:'2px', lineHeight:1 }}>
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <button className="sbtn" type="submit" disabled={loading}>
              {loading ? '⏳ Signing in...' : 'Sign in →'}
            </button>
          </form>

          <div style={{ marginTop:'32px', padding:'18px', background:'#f8fafc', borderRadius:'12px', border:'1px solid #e8edf2' }}>
            <p style={{ margin:'0 0 4px', fontSize:'11px', fontWeight:'700', color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.5px' }}>Need help?</p>
            <p style={{ margin:0, fontSize:'13px', color:'#64748b', lineHeight:1.5 }}>Contact your system administrator for account access.</p>
          </div>

          {!isBranded && (
            <p style={{ marginTop:'24px', fontSize:'12px', color:'#cbd5e0', textAlign:'center' }}>
              Powered by FibraDesk · Fibralink Technologies
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
